<template>
  <div class="shop-manual">
    <h2 class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide">
      คู่มือการเชื่อมต่อ Lazada
    </h2>
    <v-divider class="tw-mt-8"></v-divider>

    <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header class="tw-font-bold"
          >วิธีสร้าง App Lazada Open Platform</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header class="tw-font-bold">
          วิธีดึงค่า App Key และ App Secret
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header class="tw-font-bold">
          วิธีเพิ่ม User ใน Channel Lazada เพื่อสร้าง Email และ Password ใหม่
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'ShopChannelManualLazada',
}
</script>

<style lang="scss" scoped>
.shop-manual {
  .v-expansion-panel::before {
    box-shadow: none !important;
  }

  .v-expansion-panel-header {
    padding-left: 0;
  }
}
</style>